import { useEffect, useState, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../../../utils/firebase/firebase.utils.js';
import { selectUser } from '../../../../../store/user/user.selector.js';
import { setCardCount } from '../../../../../store/user/user.action.js';
import { setCardData } from '../../../../../store/card/card.action.js';

// components
import HeaderBtn from '../header-btn/HeaderBtn.js';

// assets
import cardIcon from '../../../../../assets/system/icons/card-icon.png';

export default function HeaderCardCountPill({ navigateTo }) {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [collectionCardCount, setCollectionCardCount] = useState(null);
  const userUid = useMemo(() => user?.uid, [user]);

  const handleSnapshot = useCallback((docSnap) => {
    if (docSnap.exists()) {
      const { collectionCardCount: count } = docSnap.data();
      
      if (count !== collectionCardCount) {  // Only update state if count is different
        dispatch(setCardCount(count));
        if (count === 0) {
          dispatch(setCardData({}));
        }
        setCollectionCardCount(count);
      }
    }
  }, [dispatch, collectionCardCount]);

  // Firestore listener setup
  useEffect(() => {
    if (!userUid) return;  // Guard against undefined user

    
    const userDocRef = doc(db, `users/${userUid}`);

    const unsubscribe = onSnapshot(
      userDocRef,
      handleSnapshot,
      () => {}
    );

    return () => unsubscribe();  // Cleanup listener on unmount
  }, [userUid, handleSnapshot]);

  // Return null to prevent rendering when data is still loading
  if (collectionCardCount === null) {
    return null;
  }

  return (
    <Link to={navigateTo} style={{ textDecoration: 'none', color: 'inherit' }}>
      <HeaderBtn val={collectionCardCount.toLocaleString()}>
        <img src={cardIcon} alt='card count icon' />
      </HeaderBtn>
    </Link>
  );
}